module.exports = new Promise(function(resolve, reject) {
            var m = window.__MFE_MANIFEST__;
            var remoteConfig = m && m.remotes && m.remotes['dashboard'];
            var manifestEntry = remoteConfig && remoteConfig.active !== false ? remoteConfig.entry : null;
            var buildTimeEntry = 'https://dashboard.preprod.streetsmartvision.com/remoteEntry.js';
            var entry = manifestEntry || buildTimeEntry;
            if (!entry) {
                reject(new Error('[Shell] dashboard remote URL not configured. Run: pnpm dev:env'));
                return;
            }
            // MfeLoader sets this flag right before an error-recovery reload so the
            // very next remoteEntry.js fetch is guaranteed fresh — bypassing any copy
            // a browser cached as immutable before this MFE started serving no-store
            // headers (see infra/createFrontendApp.ts). A plain reload cannot force
            // that bypass on its own since the cache lookup happens before any request
            // is sent; changing the URL is the only reliable way to skip a stale entry.
            try {
                if (sessionStorage.getItem('__mfe_force_fresh_remote__')) {
                    sessionStorage.removeItem('__mfe_force_fresh_remote__');
                    entry += (entry.indexOf('?') === -1 ? '?' : '&') + '_fresh=' + Date.now();
                }
            } catch (e) {}
            var script = document.createElement('script');
            script.src = entry;
            script.onload = function() {
                var container = window['dashboard'];
                if (!container) {
                    reject(new Error('[Shell] dashboard remote loaded but container not registered. URL may be incorrect: ' + entry));
                    return;
                }
                resolve(container);
            };
            script.onerror = function() {
                if (manifestEntry && buildTimeEntry && entry === manifestEntry) {
                    console.warn('[Shell] dashboard: manifest URL failed, retrying with env var URL');
                    var fallback = document.createElement('script');
                    fallback.src = buildTimeEntry;
                    fallback.onload = function() {
                        var container = window['dashboard'];
                        if (!container) {
                            reject(new Error('[Shell] dashboard remote loaded but container not registered on fallback. URL may be incorrect: ' + fallback.src));
                            return;
                        }
                        resolve(container);
                    };
                    fallback.onerror = function() {
                        reject(new Error('[Shell] Failed to load dashboard remote entry from all configured sources. Last attempted: ' + fallback.src));
                    };
                    document.head.appendChild(fallback);
                } else {
                    reject(new Error('[Shell] Failed to load dashboard remote entry from: ' + entry));
                }
            };
            document.head.appendChild(script);
        });